import TagsListManager from './TagsListManager'

export default TagsListManager
